import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/features/string/repeat';
import './polyfill'

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

function renderApp() {
  ReactDOM.render(<App />, document.getElementById('root'));
}

if (process.env.REACT_APP_MSW === 'true') {
  // safeStart() throws if called outside localhost — guards against accidental production builds.
  // Await before render so MSW intercepts the first network requests (no race condition).
  // On failure: do NOT fall back to renderApp(). When mocks are explicitly requested, a startup
  // failure must be visible (empty #root → Playwright smoke fails red) rather than silently
  // serving live endpoints.
  const { safeStart } = require('./tests/mocks/browser') as typeof import('./tests/mocks/browser');
  safeStart().then(renderApp).catch((err: Error) => {
    console.error('[MSW] Service worker failed to start — not rendering', err);
  });
} else {
  renderApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister();
